// ======================================================
// 🎥📂 DATOS PARA EL COMPONENTE CONTROL
// ======================================================

const cicontrolitems = {

  // =========================================
  // 🖼️ IMAGEN DE FONDO
  // =========================================
  background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/MSCI_001.png",


  // =========================================
  // 🔗 LINKS SUPERIORES
  // =========================================
  links: [
    { texto: "Inicio", url: "/Cinterno" },
    { texto: "Metodología", url: "/Cinterno/Metodologia" },
    { texto: "Componentes de Control", url: "/Cinterno/Control" },
    { texto: "Organigrama", url: "/Cinterno/Organigrama" },
    { texto: "Evidencias", url: "/Cinterno/Evidencias" }
  ],


  // =========================================
  // 🎥 SECCIÓN DE VIDEO (ANTES DEL ACORDEÓN)
  // =========================================
  videos: [
    {
      id: 1,
      titulo: "",
      url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Control_Interno.mp4"
    }
  ],


  // =========================================
  // 📂 ESTRUCTURA DEL ACORDEÓN (DEBAJO DEL VIDEO)
  // =========================================
  acordeon: [

    // 🔹 SECCIÓN 1
    {
      titulo: "Ambiente de Control",
      archivos: [
        {
          nombre: "Estrategia de difusión del Código de Ética y Código de Conducta",
          url: "/Documento/80"
        },
      ]
    },

    // 🔹 SECCIÓN 2
    {
      titulo: "Administración de Riesgos",
      archivos: [
       
      ]
    },

    // 🔹 SECCIÓN 3
    {
      titulo: "Actividades de Control",
      archivos: [
       {
          nombre: "Diagnostico de Políticas Operativas de los Programas Sociales: Bienestar de Madres Trabajadoras y Apoyo Para el Bienestar y Desarrollo",
          url: "/Documento/81"
        },
        {
          nombre: "Guía de Políticas Operativas 2025",
          url: "/Documento/82"
        },
        {
          nombre: "Informe FODA de los Líneamientos de Comunicación Interna y Externa",
          url: "/Documento/83"
        },
        {
          nombre: "Informe de la Evaluación de Control Interno",
          url: "/Documento/84"
        },

      ]
    },

    // 🔹 SECCIÓN 4
    {
      titulo: "Información y Comunicación",
      archivos: [
        {
          nombre: "Lineamientos que Regulan el Mecanismo de Registro, Análisis y Atención Oportuna y Suficiente de las Quejas y Denuncias Presentadas a Través del Buzón y Correo Electrónico de la Secretaría de Bienestar e Inclusión Social",
          url: "/Documento/89"
        },
        {
          nombre: "Lineamientos de Comunicación Interna y Externa de la Secretaría de Bienestar e Inclusión Social",
          url: "/Documento/85"
        },
        {
          nombre: "Políticas de Seguridad para los Sistemas Informáticos que se manejan en la Secretaría de Bienestar e Inclusión Social",
          url: "/Documento/86"
        },
         {
          nombre: "Lineamientos para los Criterios de Calidad para la Correcta Formalización de la Documentación en la SEBISO",
          url: "/Documento/87"
        },
         {
          nombre: "Lineamientos de Elaboración de Manuales de Procesos",
          url: "/Documento/88"
        },
      ]
    },

    // 🔹 SECCIÓN 5
    {
      titulo: "Supervisión y Mejora Continua",
      archivos: [
       
      ]
    }

  ]

};

export default cicontrolitems;